import { RECOGNITION_METHOD_LABELS } from "@common/constants/domains/accounting/schedules";
import { RecognitionMethod } from "@common/types/domains/accounting/schedule";

export enum SchedulesReportLayout {
    rollforward = "rollforward",
    waterfall = "waterfall",
}

export enum SchedulesReportRows {
    bySchedule = "bySchedule",
    byCounterparty = "byCounterparty",
    byStartMonth = "byStartMonth",
    startMonthSummary = "startMonthSummary",
}

export enum SchedulesReportRevenueSubMode {
    all = "all",
    deferred = "deferred",
    accrued = "accrued",
}

/** Method filter: how the schedules in scope recognize revenue. */
export enum SchedulesReportMethod {
    all = "all",
    straightLine = "straightLine",
    dailyProRata = "dailyProRata",
    pointInTime = "pointInTime",
    milestone = "milestone",
}

export const SCHEDULES_REPORT_METHOD_LABELS: Record<
    SchedulesReportMethod,
    string
> = {
    [SchedulesReportMethod.all]: "All",
    [SchedulesReportMethod.straightLine]:
        RECOGNITION_METHOD_LABELS[RecognitionMethod.straightLine],
    [SchedulesReportMethod.dailyProRata]:
        RECOGNITION_METHOD_LABELS[RecognitionMethod.dailyProRata],
    [SchedulesReportMethod.pointInTime]:
        RECOGNITION_METHOD_LABELS[RecognitionMethod.pointInTime],
    [SchedulesReportMethod.milestone]:
        RECOGNITION_METHOD_LABELS[RecognitionMethod.milestone],
};

export enum SchedulesReportRowKind {
    template = "template",
    application = "application",
    templateTotal = "templateTotal",
    holdingAccountSubtotal = "holdingAccountSubtotal",
    counterparty = "counterparty",
    counterpartyTotal = "counterpartyTotal",
    startPeriod = "startPeriod",
    grandTotal = "grandTotal",
    analysisCurrent = "analysisCurrent",
    analysisNonCurrent = "analysisNonCurrent",
}

export const SCHEDULES_REPORT_LAYOUT_LABELS: Record<
    SchedulesReportLayout,
    string
> = {
    [SchedulesReportLayout.rollforward]: "Rollforward",
    [SchedulesReportLayout.waterfall]: "Waterfall",
};

export const SCHEDULES_REPORT_TITLES: Record<SchedulesReportLayout, string> = {
    [SchedulesReportLayout.rollforward]: "Revenue Rollforward",
    [SchedulesReportLayout.waterfall]: "Revenue Waterfall",
};

export const SCHEDULES_REPORT_ROWS_LABELS: Record<SchedulesReportRows, string> =
    {
        [SchedulesReportRows.bySchedule]: "By schedule",
        [SchedulesReportRows.byCounterparty]: "By counterparty",
        [SchedulesReportRows.byStartMonth]: "By start month",
        [SchedulesReportRows.startMonthSummary]: "Start month summary",
    };

export const SCHEDULES_REPORT_REVENUE_SUB_MODE_LABELS: Record<
    SchedulesReportRevenueSubMode,
    string
> = {
    [SchedulesReportRevenueSubMode.all]: "All",
    [SchedulesReportRevenueSubMode.deferred]: "Deferred",
    [SchedulesReportRevenueSubMode.accrued]: "Accrued",
};

export enum SchedulesRollforwardColumn {
    beginning = "beginning",
    additions = "additions",
    recognized = "recognized",
    adjustments = "adjustments",
    ending = "ending",
}

export const SCHEDULES_ROLLFORWARD_COLUMNS: readonly SchedulesRollforwardColumn[] =
    [
        SchedulesRollforwardColumn.beginning,
        SchedulesRollforwardColumn.additions,
        SchedulesRollforwardColumn.recognized,
        SchedulesRollforwardColumn.adjustments,
        SchedulesRollforwardColumn.ending,
    ];

export const SCHEDULES_ROLLFORWARD_COLUMN_LABELS: Record<
    SchedulesRollforwardColumn,
    string
> = {
    [SchedulesRollforwardColumn.beginning]: "Beginning",
    [SchedulesRollforwardColumn.additions]: "Additions",
    [SchedulesRollforwardColumn.recognized]: "Recognized",
    [SchedulesRollforwardColumn.adjustments]: "Adjustments",
    [SchedulesRollforwardColumn.ending]: "Ending",
};

export const SCHEDULES_WATERFALL_COLUMN_LABEL = "Recognized";
